const MODULE_URL = 'connectivity';
export default {
  MODULE_URL: MODULE_URL,
  DETECT_URL: MODULE_URL + '/detect',
  STATUS_URL: MODULE_URL + '/status',

  CONNECTIVITY_MESSAGE: 'connectivity_detection_message',
  CONNECTIVITY_STARTED: 'connectivity_detection_started',
  CONNECTIVITY_FINISHED: 'connectivity_detection_finished',
};
